"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createObjectDefinition = exports.createArrayDefinition = exports.createStringDefinition = exports.createBooleanDefinition = exports.createNumberDefinition = void 0;
/**
 * Create a number definition
 * @param isOptional Whether this property is optional
 * @param value Optional value of the number
 * @param minValue Optional minimum value
 * @param maxValue Optional maximum value
 * @param allowNull Allow the property to be null
 * @returns The number definition object
 */
function createNumberDefinition(isOptional, value, minValue, maxValue, allowNull) {
    return {
        type: 1 /* Number */,
        isOptional: isOptional,
        value: value,
        maxValue: maxValue,
        minValue: minValue,
        allowNull: allowNull,
    };
}
exports.createNumberDefinition = createNumberDefinition;
/**
 * Create a boolean definition
 * @param isOptional  Whether this property is optional
 * @param value Optional expected boolean value
 * @param allowNull Allow the property to be null
 * @returns  The boolean definition object
 */
function createBooleanDefinition(isOptional, value, allowNull) {
    return {
        type: 0 /* Boolean */,
        isOptional: isOptional,
        value: value,
        allowNull: allowNull,
    };
}
exports.createBooleanDefinition = createBooleanDefinition;
/**
 * Create a string definition
 * @param isOptional  Whether this property is optional
 * @param value Optional expected string value
 * @param allowNull Allow the property to be null
 * @returns  The string definition object
 */
function createStringDefinition(isOptional, value, allowNull) {
    return {
        type: 2 /* String */,
        isOptional: isOptional,
        value: value,
        allowNull: allowNull,
    };
}
exports.createStringDefinition = createStringDefinition;
/**
 * Create an array definition
 * @param itemDef Definition of each item of the related array
 * @param isOptional  Whether this property is optional
 * @param allowNull Allow the property to be null
 * @returns  The array definition object
 */
function createArrayDefinition(itemDef, isOptional, minLength, maxLength, allowNull) {
    return {
        type: 3 /* Array */,
        isOptional: isOptional,
        itemDef: itemDef,
        minLength: minLength,
        maxLength: maxLength,
        allowNull: allowNull,
    };
}
exports.createArrayDefinition = createArrayDefinition;
/**
 * Create an object definition
 * @param propertyDef Definition of each property of the related object
 * @param isOptional  Whether this property is optional
 * @param allowNull Allow the property to be null
 * @returns  The object definition object
 */
function createObjectDefinition(propertyDef, isOptional, allowNull) {
    return {
        type: 4 /* Object */,
        isOptional: isOptional,
        propertyDef: propertyDef,
        allowNull: allowNull,
    };
}
exports.createObjectDefinition = createObjectDefinition;
//# sourceMappingURL=definitionCreators.js.map